import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.timers";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
// StickyFooter is always visible when useMobileStickyFooter (globals) is true
// and showMobileStickyFooter (settings) is true.
// StickyFooter is conditionally visible when showMobileStickyFooter is false:
//   * When page content is scrollable and scroll position is at the bottom
//   * When page content is not scrollable and user swipes up
import React, { useState, useRef, useContext, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Block from 'wfui-digital-core/es/Block';
import useStrings from 'wfui-digital-core/es/useStrings';
import useDevice from 'wfui-digital-core/es/useDevice';
import useWindowBounds from 'wfui-digital-core/es/useWindowBounds';
import NavigationContext from 'wfui-digital-core/es/NavigationContext';
import logger from 'wfui-digital-core/es/lib/logger/logger';
import { getClasses, unique } from 'wfui-digital-core/es/lib';
import globals from '../../lib/globals/globals';
import navigate from '../../lib/navigation/navigate';
import useSettings from '../hooks/use-settings';
import useScrolled from './support/use-scrolled';
import useScrollPosition from '../hooks/use-scroll-position';
import StickyFooterContext from './context/StickyFooterContext';
import Tiles from './tiles/Tiles';
import Menu from './menu/Menu';
import styles from './StickyFooter.less';
import useOrientation from './support/use-orientation';

var getIsVisible = function getIsVisible(_ref) {
  var orientation = _ref.orientation,
      showMobileStickyFooter = _ref.showMobileStickyFooter,
      forceMobileStickyFooter = _ref.forceMobileStickyFooter,
      atBottom = _ref.atBottom,
      scrollable = _ref.scrollable,
      hasScrolled = _ref.hasScrolled,
      scrollDirection = _ref.scrollDirection;
  var visible;

  if ('portrait' === orientation) {
    visible = showMobileStickyFooter || forceMobileStickyFooter || // NOSONAR
    !showMobileStickyFooter && atBottom && scrollable; // NOSONAR
  } else {
    visible = !hasScrolled || forceMobileStickyFooter || showMobileStickyFooter && hasScrolled && 'up' === scrollDirection || scrollable && atBottom;
  }

  return visible;
};

var StickyFooterContent = function StickyFooterContent(_ref2) {
  var menuConfig = _ref2.menuConfig;

  var _globals = globals(),
      pageId = _globals.pageId;

  var dispatch = useDispatch();

  var _useSettings = useSettings(),
      showMobileStickyFooter = _useSettings.showMobileStickyFooter,
      forceMobileStickyFooter = _useSettings.forceMobileStickyFooter;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      menuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      menuClosing = _useState4[0],
      setMenuClosing = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      headerContent = _useState6[0],
      setHeaderContent = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      secondaryMenu = _useState8[0],
      setSecondaryMenu = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      currentMenuItem = _useState10[0],
      setCurrentMenuItem = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      animationDirection = _useState12[0],
      setAnimationDirection = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      hasAnimatedDown = _useState14[0],
      setHasAnimatedDown = _useState14[1];

  var headingId = useRef(unique());
  var secondaryMenuId = useRef(unique());
  var containerRef = useRef();
  var headingRef = useRef();
  var visibleRef = useRef(false);

  var _useDevice = useDevice(),
      keyboardOpen = _useDevice.keyboardOpen;

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  var _useScrollPosition = useScrollPosition({
    wait: 200
  }),
      atBottom = _useScrollPosition.atBottom,
      scrollable = _useScrollPosition.scrollable,
      scrollPosition = _useScrollPosition.y,
      scrollDirection = _useScrollPosition.vd;

  var hasScrolled = useScrolled(scrollPosition);
  var orientation = useOrientation();

  var _useWindowBounds = useWindowBounds(),
      windowHeight = _useWindowBounds.height,
      windowWidth = _useWindowBounds.width;

  useEffect(function () {
    !pageId && logger.error('mwfGlobals.pageId is not defined');
  }, [dispatch, pageId]);
  var visible = getIsVisible({
    orientation: orientation,
    showMobileStickyFooter: showMobileStickyFooter,
    forceMobileStickyFooter: forceMobileStickyFooter,
    atBottom: atBottom,
    scrollable: scrollable,
    hasScrolled: hasScrolled,
    scrollDirection: scrollDirection
  });

  if (visibleRef.current !== visible) {
    setAnimationDirection(visible ? 'up' : 'down');
    visibleRef.current = visible;
  }

  useEffect(function () {
    if ('down' === animationDirection) {
      setHasAnimatedDown(true);
    }
  }, [animationDirection]);
  useEffect(function () {
    !secondaryMenu && setHeaderContent(menuConfig.sections[1].label);
  }, [menuConfig.sections, secondaryMenu]);
  useEffect(function () {
    var timeout;

    if (menuClosing) {
      timeout = setTimeout(function () {
        setMenuOpen(false);
        setMenuClosing(false);
        setSecondaryMenu(null);
      }, 500);
    }

    return function () {
      return clearTimeout(timeout);
    };
  }, [menuClosing, setMenuOpen]);

  var navigateTo = function navigateTo(_ref3) {
    var link = _ref3.link,
        _ref3$closeMenu = _ref3.closeMenu,
        closeMenu = _ref3$closeMenu === void 0 ? true : _ref3$closeMenu;

    if (closeMenu) {
      setMenuClosing(true);
      setTimeout(function () {
        return navigate({
          dispatch: dispatch,
          link: link
        });
      }, 500);
    } else {
      navigate({
        dispatch: dispatch,
        link: link
      });
    }
  };

  var footerHeight = containerRef.current ? containerRef.current.clientHeight : 0;
  var openMenu = useCallback(function () {
    setMenuOpen(true);
  }, []);
  var closeMenu = useCallback(function () {
    !menuClosing && menuOpen && setMenuClosing(true);
  }, [menuClosing, menuOpen]);
  var context = {
    pageId: pageId,
    menuConfig: menuConfig,
    menuOpen: menuOpen,
    menuClosing: menuClosing,
    headingId: headingId.current,
    getString: getString,
    openMenu: openMenu,
    closeMenu: closeMenu,
    navigate: navigateTo,
    secondaryMenu: secondaryMenu,
    setSecondaryMenu: setSecondaryMenu,
    secondaryMenuId: secondaryMenuId.current,
    headerContent: headerContent,
    setHeaderContent: setHeaderContent,
    windowHeight: windowHeight,
    windowWidth: windowWidth,
    footerHeight: footerHeight,
    currentMenuItem: currentMenuItem,
    setCurrentMenuItem: setCurrentMenuItem,
    headingRef: headingRef
  };
  var classes = ['footer', animationDirection === 'up' && hasAnimatedDown && 'slideUp', animationDirection === 'down' && 'slideDown', visible && 'visible'];
  var classNames = getClasses({
    styles: styles,
    classes: classes
  });
  return pageId && menuConfig && !keyboardOpen ? /*#__PURE__*/React.createElement(StickyFooterContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    justifyCenter: true,
    elementRef: containerRef,
    className: classNames,
    "data-testid": "stickyFooter",
    "data-visible": visible
  }, /*#__PURE__*/React.createElement(StickyFooterContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(Tiles, null))), /*#__PURE__*/React.createElement(Menu, null))) : null;
};

var StickyFooter = function StickyFooter() {
  var _useContext = useContext(NavigationContext),
      getContainer = _useContext.getContainer;

  var menuConfig = getContainer('NAVBAR');
  return menuConfig ? /*#__PURE__*/React.createElement(StickyFooterContent, {
    menuConfig: menuConfig
  }) : null;
};

export default StickyFooter;